// ─── content.js ───────────────────────────────────────────────────────────────
// All editable site content lives here.
// The admin page reads/writes this via src/lib/api.js
// To go production: replace api.js localStorage calls with Supabase.
// ──────────────────────────────────────────────────────────────────────────────

export const SITE_DEFAULTS = {

  hero: {
    // Legacy fields (kept for compatibility)
    eyebrow: 'Premium Cuts. Real Craft.',
    slogans: ['Sharp Fades.', 'Clean Lines.', 'Stay Fresh.', 'Book Now.'],
    ctaEyebrow: 'Walk in looking good. Leave looking dangerous.',
    ctaHeadline: 'Your Best Cut,',
    // Active hero fields (read by Hero.jsx)
    tagline: "FRASER VALLEY'S PREMIER BARBERSHOP",
    heroWords: ['SHARP FADES', 'CLEAN LINES', 'FRESH CUTS', 'REAL STYLE'],
    description: "Award-winning barbers in Abbotsford & Surrey and the Fraser Valley delivering precision fades, classic cuts, and modern styles. Where craftsmanship meets confidence.",
    bookingUrl: 'https://getsquire.com/booking/brands/bro-code-barbershop',
    beforeImage: 'https://brocode.b-cdn.net/Screenshot%202026-03-15%20at%2012.09.38%E2%80%AFPM.png',
    afterImage: 'https://brocode.b-cdn.net/hf_20260315_193425_f9b645e9-d929-4d2d-b0cf-15a2e106c8c1.jpeg',
    ctaPrimary: 'BOOK YOUR CUT',
    ctaSecondary: 'VIEW SERVICES',
    trustStats: [
      { number: '400+', label: '5-Star Reviews' },
      { number: '2',    label: 'Locations' },
      { number: '8',    label: 'Team Members' },
    ],
  },

  about: {
    heading1: "We Don't",
    heading2: 'We',
    highlight1: 'Cut.',
    highlight2: 'Sculpt.',
    para1: "Brocode isn't your average barbershop. We're a culture — built on sharp technique, real conversation, and the belief that every man deserves to walk out looking like the best version of himself. No shortcuts. No excuses.",
    para2: "Our barbers train obsessively, stay ahead of every trend, and treat each client like family. Whether it's a clean taper, a full beard sculpt, or a straight razor finish — we go hard on every single cut, every single time.",
    aboutImage: 'https://brocode.b-cdn.net/DSC00403.webp',
    stats: [
      { value: 12,   suffix: '+', label: 'Years of Craft' },
      { value: 4800, suffix: '+', label: 'Happy Clients' },
      { value: 2,    suffix: '',  label: 'Locations' },
      { value: 98,   suffix: '%', label: 'Come Back Rate' },
    ],
  },

  services: [
    {
      id: 'haircuts',
      title: 'Haircuts',
      image: 'https://brocode.b-cdn.net/DSC_0675-ezgif.com-video-to-gif-converter.gif',
      content: [
        {
          intro: 'From classic cuts to the latest trends, we specialize in every style you can imagine:',
          items: [
            'Skin fades, low/mid/high fades, taper cuts, crew & buzz cuts, slick backs, textured or messy styles.'
          ],
          outro: null,
        },
      ],
    },
    {
      id: 'beard',
      title: 'Beard Trims & Styling',
      image: 'https://brocode.b-cdn.net/DSC_0026-ezgif.com-video-to-gif-converter.gif',
      content: [
        {
          intro: 'Beard grooming is an art—and our barbers are the artists. We offer complete beard care solutions, including:',
          items: [
            'Beard shaping and sculpting, beard fades, goatee and stubble styling, luxury beard treatments, full beard transformations, and clean shaves.'
          ],
        },
      ],
    },
    {
      id: 'other',
      title: 'Other Serivces',
      image: 'https://brocode.b-cdn.net/DSC_0105-ezgif.com-video-to-gif-converter.gif',
      content: [
        {
          intro: null,
          items: [
            'Nose Waxing – Gentle and precise for a clean, polished look',
            'Head Massages – Melt stress away and rejuvenate your mind and body',
            'Eyebrow & Facial Threading – Expertly sculpted brows and flawless facial grooming',
            'Tattoos – Express yourself with unique, professional designs',
            'Facials – Refresh, nourish, and rejuvenate your skin'
          ],
        },
      ],
    },
  ],

  locations: [
    {
      id: 'abbotsford',
      number: '01',
      city: 'Abbotsford',
      address: '1779 Clearbrook Rd #123',
      unit: '',
      postalCode: 'V2T5X5',
      phone: '(236) 899-0603',
      mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2608.0!2d-122.3107!3d49.0504!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5485d9b2b9b2b9b3%3A0x1!2s1779+Clearbrook+Rd+%23123%2C+Abbotsford%2C+BC!5e0!3m2!1sen!2sca!4v1708000000000',
    },
    {
      id: 'surrey',
      number: '02',
      city: 'Surrey',
      address: '5631 176a St',
      unit: 'Unit B',
      postalCode: 'V3S4G8',
      phone: '(236) 899-0603',
      mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2611.0!2d-122.7358!3d49.1073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5485d3e0a0e4b0b1%3A0x1!2s5631+176a+St+Unit+B%2C+Surrey%2C+BC!5e0!3m2!1sen!2sca!4v1708000000001',
    },
  ],

  // team: unified structure used by Team.jsx (orbit), OurTeam.jsx (grid), and Admin
  // bio format: "X+ Years • Specialty One • Specialty Two" (• separated)
  // category: 'leadership' | 'barber' | 'tattoo'
  teamRosterVersion: 1,
  team: [
    { id: 1, name: 'SAHIL', role: 'FOUNDER',                     img: 'https://brocode.b-cdn.net/barbers/DSC03734.JPG',   bio: '12+ Years Experience • All Styles & Precision Cuts',                                    imgPosition: 'center 50%', category: 'leadership' },
    { id: 2, name: 'RAJ',   role: 'CO-OWNER',                    img: 'https://brocode.b-cdn.net/barbers/Meet%20Raj.JPEG', bio: '9+ Years Experience • Precision Fades & Classic Cuts',                               imgPosition: 'center 50%', category: 'leadership' },
    { id: 5, name: 'PERRY', role: 'MANAGER – SURREY LOCATION',   img: 'https://brocode.b-cdn.net/barbers/IMG_1176.JPG',   bio: '4+ Years Experience • Fast • Efficient • Surrey Team Star',                           imgPosition: 'center 50%', category: 'barber'     },
    { id: 7, name: 'AMMY',  role: 'BARBER',                      img: 'https://brocode.b-cdn.net/barbers/DSC_0584.JPEG',  bio: '3+ Years Experience • New to the Team • Great Conversations • Clean Clipper Work',   imgPosition: 'center 60%', category: 'barber'     },
    { id: 8, name: 'RONY',  role: 'BARBER',                      img: 'https://brocode.b-cdn.net/DSC_0704.JPG',            bio: '2+ Years Experience • Youngest on the Team • Rising Star',                           imgPosition: 'center 60%', category: 'barber'     },
    { id: 10, name: 'NITIN', role: 'BARBER', img: '/barbers/nitin.webp', bio: '', imgPosition: 'center 30%', category: 'barber' },
    { id: 11, name: 'BAL', role: 'BARBER', img: '/barbers/bal.webp', bio: '', imgPosition: 'center 30%', category: 'barber' },
    { id: 9, name: 'GURDAS',role: 'TATTOO ARTIST',               img: 'https://brocode.b-cdn.net/barbers/IMG_0461.png',   bio: '2+ Years Experience • Shading • Filling • Script • All Styles',                      imgPosition: 'center 50%', category: 'tattoo'     },
  ],

  gallery: [
  { id: 'g1', image: 'https://brocode.b-cdn.net/brocode/98AED732-B703-43F8-89D7-4F6F52DC6D02.jpg' },
  { id: 'g2', image: 'https://brocode.b-cdn.net/brocode/CAD95F2A-7B9C-40B8-ADED-B65F22432548.jpg' },
  { id: 'g3', image: 'https://brocode.b-cdn.net/brocode/DSC03708.jpg' },
  { id: 'g4', image: 'https://brocode.b-cdn.net/brocode/DSC03711.jpg' },
  { id: 'g5', image: 'https://brocode.b-cdn.net/brocode/DSC03712.jpg' },
  { id: 'g6', image: 'https://brocode.b-cdn.net/brocode/DSC03714.jpg' },
  { id: 'g7', image: 'https://brocode.b-cdn.net/brocode/DSC03716.jpg' },
  { id: 'g8', image: 'https://brocode.b-cdn.net/brocode/DSC03734.jpg' },
  { id: 'g9', image: 'https://brocode.b-cdn.net/brocode/DSC03764.jpg' },
  { id: 'g10', image: 'https://brocode.b-cdn.net/brocode/DSC03768.jpg' },
  { id: 'g11', image: 'https://brocode.b-cdn.net/brocode/DSC03771.jpg' },
  { id: 'g12', image: 'https://brocode.b-cdn.net/brocode/DSC03780.jpg' },
  { id: 'g13', image: 'https://brocode.b-cdn.net/brocode/DSC03784.jpg' },
  { id: 'g14', image: 'https://brocode.b-cdn.net/brocode/DSC03790.jpg' },
  { id: 'g15', image: 'https://brocode.b-cdn.net/brocode/DSC03791.jpg' },
  { id: 'g16', image: 'https://brocode.b-cdn.net/brocode/DSC03814.jpg' },
  { id: 'g17', image: 'https://brocode.b-cdn.net/brocode/DSC03823.jpg' },
  { id: 'g18', image: 'https://brocode.b-cdn.net/brocode/DSC03849.jpg' },
  { id: 'g19', image: 'https://brocode.b-cdn.net/brocode/DSC03854.jpg' },
  { id: 'g20', image: 'https://brocode.b-cdn.net/brocode/DSC03860.jpg' },
  { id: 'g21', image: 'https://brocode.b-cdn.net/brocode/DSC03864.jpg' },
  { id: 'g22', image: 'https://brocode.b-cdn.net/brocode/DSC03869.jpg' },
]

};
